import { useContext } from 'react';
import { DataContext } from '../context/DataContextValue.js';

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    console.error('useData must be used within a DataProvider');
    return {};
  }
  return context;
};
